<app-aps-brokerage-search-side-form-input
	*ngIf="!brokerage"
	[label]="label"
	[skeletonLoading]="skeletonLoading"
	(onCreate)="_onCreate($event)"
	[isClient]="isClient"
	[showAiIcon]="showAiIcon$ | async"
	(onSelectedBroker)="selectBroker($event)"
	(onSelectedBrokerage)="selectBrokerage($event)"
	(onFocus)="_onFocus()"
></app-aps-brokerage-search-side-form-input>
<ng-container *ngIf="!skeletonLoading; else skeletonLoader">
	<div [@openClose] *ngIf="showCreateForm" class="m-2">
		<app-create-brokerage-side-form
			(onCreate)="onCreated($event)"
			(onCancel)="onCancel()"
			[isClient]="isClient"
			[name]="searchedValue"
		></app-create-brokerage-side-form>
	</div>

	<div *ngIf="brokerage" class="flex flex-col gap-2">
		<div class="flex flex-col gap-1">
			<div class="flex gap-2">
				<label>{{ sellerBuyerBrokerLabel }} Brokerage</label>
				<app-icon
					[icon]="AI_ICON"
					[classes]="AI_CLASSES"
					*ngIf="(showAiFlags$ | async)?.brokerage"
					[matTooltip]="AI_TOOLTIP"
				></app-icon>
			</div>
			<app-firm-card
				[name]="brokerage?.name"
				[address]="setAddress(brokerage?.address)"
				[phone]="brokerage?.phoneNumber"
				[fax]="brokerage?.faxNumber"
				[email]="brokerage?.email"
				member="BROKERAGE"
				memberType="Business"
				[hoverShadow]="hoverShadow"
				(dropdown)="brokerageDropdownOptionSelect($event)"
				[testHook]="testHooks.FirmCard"
			>
			</app-firm-card>
		</div>
		<div class="flex flex-col gap-1">
			<div *ngIf="brokerage?.broker" class="flex gap-2">
				<label>{{ sellerBuyerBrokerLabel }} Agent</label>
				<app-icon
					[icon]="AI_ICON"
					[classes]="AI_CLASSES"
					*ngIf="(showAiFlags$ | async)?.broker"
					[matTooltip]="AI_TOOLTIP"
				></app-icon>
			</div>
			<app-broker-side-form
				[isClient]="isClient"
				[broker]="brokerage?.broker"
				[brokerage]="brokerage"
				(onSelectedBroker)="selectBroker($event)"
				(onRemoveBroker)="removeBroker()"
				(onCreateBroker)="createBroker($event)"
				(onFocus)="_onFocus()"
			></app-broker-side-form>
		</div>
	</div>
</ng-container>

<ng-template #skeletonLoader>
	<ui-skeleton-loader type="party-card" />
</ng-template>
